import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addNotification, addErrorNotification } from './notificationsSlice';

const initialState = {
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
  accountType: localStorage.getItem('accountType'),
  username: localStorage.getItem('username'),
  entityName: localStorage.getItem('entityName'),
  showNavbarAndFooter: true,
};

// ---------------------- ASYNC THUNKS ----------------------

export const handleLogin = createAsyncThunk(
  'app/handleLogin',
  async (args, thunkAPI) => {
    const { email, password } = args;
    const res = await requests.handleLogin(email, password);
    const { ok } = res;
    const body = await res.json();

    if (ok) {
      thunkAPI.dispatch(addNotification('Login Successful!'));
    } else {
      // Check if account requires verification
      if (body.requiresVerification) {
        thunkAPI.dispatch(addNotification('Please verify your email to continue'));
      } else {
        const errmsg = body.errmsg || 'Something Went Wrong When Logging In!';
        thunkAPI.dispatch(addErrorNotification(errmsg));
      }
    }

    return { ok, body };
  }
);

export const handleLogout = createAsyncThunk('app/handleLogout', async () => {
  const res = await requests.handleLogout();
  return { ok: res.ok };
});

// ---------------------- SLICE ----------------------

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    hideNavbarAndFooter: (state) => {
      state.showNavbarAndFooter = false;
    },
    showNavbarAndFooter: (state) => {
      state.showNavbarAndFooter = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleLogin.fulfilled, (state, { payload }) => {
        const { ok, body } = payload;

        if (ok) {
          console.log(body);
          const { accountType, username, entityName } = body;
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('accountType', accountType);
          localStorage.setItem('username', username);
          localStorage.setItem('entityName', entityName);
          state.isLoggedIn = true;
          state.accountType = accountType;
          state.username = username;
          state.entityName = entityName;
        }
      })
      .addCase(handleLogout.fulfilled, (state) => {
        localStorage.setItem('isLoggedIn', false);
        localStorage.removeItem('accountType');
        localStorage.removeItem('entityName');
        state.isLoggedIn = false;
        state.accountType = null;
      });
  },
});

export const { hideNavbarAndFooter, showNavbarAndFooter } = appSlice.actions;
export default appSlice.reducer;
